/**
 * @file editopic-actions.js
 */

/* globals xaf */

import {Url} from '@/utils/api.js';
import {get, post} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';

export default {
    // 初始化数据
    initPageConfig({commit, state}, {type, id, query}) {
        let params = {};
        switch (state.routeName) {
            case 'editTopic':
            case 'editIssue':
                params.topicId = id;
                commit('setTopicId', id);
                break;

        }
        let url = Url.addTopicSourceUrl;
        return get(url, params)
            .then(data => {
                commit('initPageConfig', {data, query});
                if (state.routeName !== 'addTopic'
                    && data.topicInfo
                    && Object.keys(data.topicInfo).length) {
                    // 编辑页需填充已有内容
                    commit('setExistContent', data.topicInfo);
                }
            })
            .catch(errmsg => {
                toast.error(errmsg);
                return Promise.reject(errmsg);
            });
    },
    // 初始化
    init({commit, dispatch, state}, {type, routeName, id, ...query}) {
        commit('setRouteName', routeName);
        // 编辑页对文本器不再做清空处理
        if (routeName !== 'addTopic') {
            commit('setIsInputSthing', true);
        }
        return dispatch('initPageConfig', {type, id, query})
            .then(() => {
                commit('getContentPlaceholder');
            });
    },
    // 切换标签
    chooseTag({commit}, {id, idx}) {
        commit('changeTag', {id, idx});
        commit('getContentPlaceholder');
    },
    // 设置帖子标签
    setTags({commit}, value) {
        commit('setTags', value);
    },
    // 校验数据是否为空
    checkForm({commit, rootState}, {content, pureText}) {
        commit('comExtList', {
            content,
            pureText,
            contentMaxLen: rootState.common.wordLimit.contentMaxLen
        });
    },

    /**
     * 提交发帖
     * @param {string} ds 滑动验证码返回参数，用于验证是否为人机
     * @param {string} tk 滑动验证码返回参数，用于验证是否为人机
     *
     * @return {Promise<Object>} 发帖请求
     */
    submit({state, dispatch}, {ds, tk}) {
        let url = state.routeName === 'addTopic' ? Url.addTopicUrl : Url.editTopicUrl;
        // 获取昊天镜风控参数
        let {Token: to, view: vw} = xaf.getData();
        let data = Object.assign({}, state.finalResult, {to, vw, ds, tk});
        return post(url, data)
            .then(data => {
                toast.success('发帖成功');
                state.topicId = data.topicId;
                return data;
            })
            .catch(errmsg => {
                if (errmsg === Tip.notLogin) {
                    dispatch('navToExit');
                }
                else {
                    toast.error(errmsg);
                }
            });
    },
    notChangeEditor({commit}) {
        commit('notChangeEditor');
    }
};
